"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _shared = require("@clayui/shared");
var _ariaHidden = require("aria-hidden");
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _warning = _interopRequireDefault(require("warning"));
var _Body = _interopRequireDefault(require("./Body"));
var _Context = _interopRequireDefault(require("./Context"));
var _Footer = _interopRequireDefault(require("./Footer"));
var _Header = _interopRequireWildcard(require("./Header"));
var _Hook = require("./Hook");
var _types = require("./types");
var _excluded = ["center", "children", "className", "containerElementRef", "containerProps", "disableAutoClose", "observer", "role", "size", "spritemap", "status", "zIndex"];
/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var warningMessage = "You need to pass the 'observer' prop to ClayModal for everything to work fine, use the 'useModal' hook that exposes the observer.\n\n> const {observer} = useModal({...});\n>\n> return (\n> \t<ClayModal observer={observer}>\n> \t\t...\n> \t</ClayModal>\n> );\n";
var counter = 0;
var Modal = function Modal(_ref) {
  var _classNames;
  var center = _ref.center,
    children = _ref.children,
    className = _ref.className,
    containerElementRef = _ref.containerElementRef,
    _ref$containerProps = _ref.containerProps,
    containerProps = _ref$containerProps === void 0 ? {} : _ref$containerProps,
    _ref$disableAutoClose = _ref.disableAutoClose,
    disableAutoClose = _ref$disableAutoClose === void 0 ? false : _ref$disableAutoClose,
    observer = _ref.observer,
    _ref$role = _ref.role,
    role = _ref$role === void 0 ? 'dialog' : _ref$role,
    size = _ref.size,
    spritemap = _ref.spritemap,
    status = _ref.status,
    zIndex = _ref.zIndex,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var modalElementRef = (0, _react.useRef)(null);
  var modalBodyElementRef = (0, _react.useRef)(null);
  var _ref2 = observer && observer.mutation ? observer.mutation : [false, false],
    _ref3 = _slicedToArray(_ref2, 2),
    show = _ref3[0],
    content = _ref3[1];
  "production" !== "production" ? (0, _warning.default)(observer !== undefined, warningMessage) : void 0;
  (0, _Hook.useUserInteractions)(modalElementRef, modalBodyElementRef, function () {
    return !disableAutoClose && observer.dispatch(_types.ObserverType.Close);
  }, show, content);
  (0, _react.useEffect)(function () {
    observer.dispatch(_types.ObserverType.RestoreFocus, document.activeElement);
    observer.dispatch(_types.ObserverType.Open);
  }, []);
  (0, _react.useEffect)(function () {
    if (modalBodyElementRef.current && show && content) {
      var focusedElement = modalBodyElementRef.current.querySelector('h1');
      if (focusedElement) {
        focusedElement.focus();
      } else {
        modalBodyElementRef.current.focus();
      }
    }
  }, [show, content]);
  var ariaLabelledby = (0, _react.useMemo)(function () {
    counter++;
    return "clay-modal-label-".concat(counter);
  }, []);
  (0, _react.useEffect)(function () {
    if (show && content) {
      _shared.stack.push(modalElementRef);
    }
    return function () {
      var index = _shared.stack.indexOf(modalElementRef);
      if (index >= 0) {
        _shared.stack.splice(index, 1);
      }
    };
  }, [show, modalElementRef, content]);
  (0, _react.useEffect)(function () {
    if (modalElementRef.current && show && _shared.stack[_shared.stack.length - 1] === modalElementRef) {
      // Hide everything from ARIA except the Modal Body
      return (0, _ariaHidden.suppressOthers)(modalElementRef.current);
    }
  }, [show]);
  return /*#__PURE__*/_react.default.createElement(_shared.ClayPortal, _extends({}, containerProps, {
    containerRef: containerElementRef,
    subPortalRef: modalElementRef
  }), /*#__PURE__*/_react.default.createElement("div", {
    "aria-hidden": "true",
    className: (0, _classnames.default)('modal-backdrop fade', {
      show: show
    }),
    style: {
      zIndex: zIndex
    }
  }), /*#__PURE__*/_react.default.createElement("div", _extends({}, otherProps, {
    className: (0, _classnames.default)('fade modal d-block', className, {
      show: show
    }),
    ref: modalElementRef,
    style: {
      zIndex: zIndex && zIndex + 10
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('modal-dialog', (_classNames = {}, _defineProperty(_classNames, "modal-".concat(size), size), _defineProperty(_classNames, "modal-".concat(status), status), _defineProperty(_classNames, 'modal-dialog-centered', center), _classNames))
  }, /*#__PURE__*/_react.default.createElement("div", {
    "aria-labelledby": ariaLabelledby,
    "aria-modal": "true",
    className: "modal-content",
    ref: modalBodyElementRef,
    role: role,
    tabIndex: -1
  }, /*#__PURE__*/_react.default.createElement(_Context.default.Provider, {
    value: {
      ariaLabelledby: ariaLabelledby,
      onClose: function onClose() {
        return observer.dispatch(_types.ObserverType.Close);
      },
      spritemap: spritemap,
      status: status
    }
  }, content && children)))));
};
Modal.Body = _Body.default;
Modal.Footer = _Footer.default;
Modal.Header = _Header.default;
Modal.Item = _Header.Item;
Modal.ItemGroup = _Header.ItemGroup;
Modal.Subtitle = _Header.Subtitle;
Modal.SubtitleSection = _Header.SubtitleSection;
Modal.Title = _Header.Title;
Modal.TitleIndicator = _Header.TitleIndicator;
Modal.TitleSection = _Header.TitleSection;
var _default = exports.default = Modal;